import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
export function ContactoPage() {
  const [iframeHeight, setIframeHeight] = useState(800);
  useEffect(() => {
    // Dynamically load the LeadConnector script
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    // Listen for resize messages from the iframe
    const handleMessage = (event: MessageEvent) => {
      if (event.data && typeof event.data === 'object' && event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        return;
      }
      // LeadConnector sends height via postMessage
      if (event.data && typeof event.data === 'string') {
        try {
          const parsed = JSON.parse(event.data);
          if (parsed.height) {
            setIframeHeight(parsed.height);
          }
        } catch {
          // not JSON, ignore
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="bg-charcoal min-h-screen" data-id="element-549">
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-550">
        <div className="max-w-3xl mx-auto text-center" data-id="element-551">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-552">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 border border-accent/20 text-accent text-xs font-semibold tracking-wide uppercase mb-6" data-id="element-553">
              Contacto
            </span>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-cream mb-6" data-id="element-554">
              Contacto
            </h1>
            <p className="text-[#b8b4ae] text-base sm:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-555">
              Reclutar no es suerte. Es un sistema que instalamos y operamos
              para ti. Llena este formulario para ser contactado por uno de
              nuestros especialistas en crecimiento.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-12" data-id="element-556">
            <iframe src="https://api.leadconnectorhq.com/widget/survey/xgFsB3vHw67EmT0qrcZk" style={{
            border: 'none',
            width: '100%',
            height: `${iframeHeight}px`
          }} scrolling="no" id="xgFsB3vHw67EmT0qrcZk" title="survey" data-id="element-557" />
          </motion.div>
        </div>
      </section>
    </div>;
}